import React, { useState, useEffect, useRef } from "react";
import PersonalDetailsStyles from "./PersonalDetails.styles";
import YhInput from "../../../../../ui/YhInput";
import YhSelect, { buildStageSelectGroups } from "../../../../../ui/YhSelect";
import YhMultiSelect from "../../../../../ui/YhMultiSelect";
import {
  PHONE_COUNTRY_OPTIONS,
  defaultPhoneCountry,
  findPhoneCountry,
} from "../../../../../Shared/Phone/PhoneWithCountryCode";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import {
  getFinalBodyStructure,
  handleValidation,
  // handleValidation,
  // handleValidation,
  initialState,
  validateInput,
} from "./Validation";
import { getAllUsers, getCountry, getState } from "./PersonalDetailsService";
import {
  RegisterEmployee,
  getPerosnalDetails,
  updatePersonalDetail,
  getRoleById,
  getLeaveDetail,
  getOfficeDetails,
} from "../StepperService";
import OrganizationSelect from "../../../../../Shared/Organization/OrganizationSelect";
import { ImageUpLoad } from "../EmployeeDocuments/EmployeeDocumentServices";
import {
  changeAt,
  changeStage,
  getAllSource,
  getAllStage,
  getAllTeam,
  getAllTeamMembersData,
} from "../../ShowAll/ShowAllService";
import {
  getAllTeamDataProject,
  getAllTeamMembersDataProject,
} from "../../../../Project/components/stepper/Personal Details/PersonalDetailsService";
import { getStage } from "../../../../MetaData/components/MetaList/components/LeadStageData/LeadStageListService";
import { store } from "../../../../../utils/store";
import { loadViewerAssignScope, loadViewerTeamIds, ViewerAssignScope } from "../../../../../helpers/assignmentScope";
const _ = require("lodash");

let clonedObject = {};

interface CustomProps {
  nextStep?: () => void | undefined;
  userId: String;
  setUserId?: Function;
  fromSettingOrLogout?: any;
  addNewTeamDialog: any;
  eventForEdit: any;
  handleCloseAddTeam: Function;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}
interface LeadOption {
  id: string;
  label: string;
  selected?: number;
}

const toLeadEntityId = (item: any): string => {
  if (item == null || item === "" || item === "NA") return "";
  if (typeof item === "string" || typeof item === "number") return String(item);
  return String(item._id || item.id || "");
};

const parseLeadAssignIds = (raw: any): string[] => {
  if (raw == null || raw === "" || raw === "NA") return [];
  if (Array.isArray(raw)) {
    return raw.map(toLeadEntityId).filter((id) => id && id !== "NA");
  }
  if (typeof raw === "string") {
    let trimmed = raw.trim();
    try {
      let parsed: any = trimmed;
      for (let i = 0; i < 3; i++) {
        if (typeof parsed !== "string") break;
        parsed = JSON.parse(parsed);
      }
      if (Array.isArray(parsed)) return parseLeadAssignIds(parsed);
      if (typeof parsed === "string") trimmed = parsed;
    } catch {
      // not JSON
    }
    return trimmed
      .replace(/^['"]+|['"]+$/g, "")
      .replace(/'/g, "")
      .split(",")
      .map((s) => s.trim().replace(/^["']+|["']+$/g, ""))
      .filter((id) => id && id !== "NA");
  }
  return [];
};

const PersonalDetails = (props: CustomProps) => {
  const countryData = PHONE_COUNTRY_OPTIONS.map((c) => ({
    label: c.label,
    code: c.code,
    dialCode: c.dialCode,
  }));
  const classes = PersonalDetailsStyles;
  const [personalDetailState, setPersonalDetailState] = useState<any>();
  // initialState({})
  const [apiResponse, setApiResponse] = useState(false);
  const [state, setState] = useState([]);
  const [formName, setFormName] = useState<any>([]);
  const [formFiels, setFormFiels] = useState<any>([]);
  const [formFielsAns, setFormFielsAns] = useState<any>([]);
  const [leadOption, setLeadOption] = useState<any>([]);
  const [stageData, setStageData] = useState<any>([]);
  const [stageSourse, setStageSourse] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  const [assignScope, setAssignScope] = useState<ViewerAssignScope | null>(null);
  const [idForMember, setIdForMember] = useState<any>([]);
  const [allSatgedata, setAllStagedata] = useState<any>([]);
  const [organizationId, setOrganizationId] = useState("");
  const uniqueLeadOptionMembers = Array.from(
    new Map(leadOptionMembers?.map((member: any) => [member.id, member])).values()
  );
  useEffect(() => {
    tableDataShowHandler();
  }, []);

  useEffect(() => {
    if (props.addNewTeamDialog?.edit && props.eventForEdit?._id) {
      tabelDataForEdit();
    }
  }, [props.eventForEdit, props.addNewTeamDialog?.edit]);

  // Resolve team chip labels once team dropdown options finish loading
  useEffect(() => {
    if (!props.addNewTeamDialog?.edit || !leadOption?.length) return;
    setSelectedOptions((prev: any) => {
      if (!Array.isArray(prev) || !prev.length) return prev;
      let changed = false;
      const next = prev.map((t: any) => {
        const match = leadOption.find(
          (o: any) => String(o.id) === String(t.id)
        );
        if (match?.label && t.label !== match.label) {
          changed = true;
          return {
            ...t,
            label: match.label,
            teamMembers: match.teamMembers || t.teamMembers,
          };
        }
        return t;
      });
      return changed ? next : prev;
    });
  }, [leadOption, props.addNewTeamDialog?.edit]);

  function splitPhone(fullPhone: any) {
    if (!fullPhone || typeof fullPhone !== "string") {
      return { dialCode: "", phoneNumber: fullPhone || "", country: null };
    }
    const matchedCountry = countryData.find((c) =>
      fullPhone.startsWith(c.dialCode)
    );

    const dialCode = matchedCountry ? matchedCountry.dialCode : "";
    const phoneNumber = dialCode ? fullPhone.slice(dialCode.length) : fullPhone;

    return { dialCode, phoneNumber, country: matchedCountry || null };
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const inputs = document.getElementsByTagName("input");
      const currentIndex = Array.from(inputs).indexOf(
        event.target as HTMLInputElement
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < inputs.length) {
        inputs[nextIndex].focus();
      } else {
        // If the last input field is reached, trigger the submitForm function
        submitForm();
      }
    }
  };


  //   const fetchData = async () => {
  //     console.log(leadOption,"assignedUsersassignedUsers")
  //     try {
  //       if (!personalDetailState?.data?.length) return;

  //       const assignedUsers = personalDetailState.data[0].AssignTo;
  //       const assignedUsers1 = personalDetailState.data[0].AssignToUser;
  //       // if (Array.isArray(assignedUsers) || assignedUsers.length > 0 || leadOption) {
  //         // Filter and prepare selected data
  //         const selectedData = leadOption
  //           .filter((option: any) =>
  //             assignedUsers.some((user: any) => user._id === option.id)
  //           )
  //           .map((option: any) => ({ ...option, selected: 1 }));

  //         // Temporarily store the selected data before updating state
  //         const tempSelectedData = [...selectedData];
  // console.log(tempSelectedData,"tempSelectedData")

  //         // Update selectedOptions and leadOption
  //         setSelectedOptions(tempSelectedData);
  //         setLeadOption((prev: any) =>
  //           prev.map((item: any) =>
  //             tempSelectedData.some((selected: any) => selected.id === item.id)
  //               ? { ...item, selected: 1 }
  //               : { ...item, selected: 0 }
  //           )
  //         );

  //         // if (assignedUsers1.length > 0) {
  //           const payload = {
  //             team_id: tempSelectedData.map((item: any) => item.id), // Use tempSelectedData here
  //             leadId: props.eventForEdit?._id,
  //           };

  //           const response1 = await getAllTeamMembersData(payload);
  //           const leadOptionMembers = response1.data.flatMap((member: any) =>
  //             member?.team_members?.map((mem: any) => {
  //               const isSelected = tempSelectedData.some(
  //                 (selected: any) => selected.id === mem.users[0]._id
  //               );
  //               return {
  //                 pId: member._id,
  //                 id: mem.users[0]._id,
  //                 label: mem.users[0]?.name,
  //                 selected: isSelected ? 1 : 0,
  //               };
  //             })
  //           );

  //           // Only update if leadOptionMembers has changed
  //           setLeadOptionMembersas((prevMembers: any[]) => {
  //             if (JSON.stringify(prevMembers) !== JSON.stringify(leadOptionMembers)) {
  //               return leadOptionMembers;
  //             }
  //             return prevMembers;
  //           });

  //           const selectedMembers = leadOptionMembers
  //             .filter((option: any) =>
  //               assignedUsers1.some((user: any) => user._id === option.id)
  //             )
  //             .map((option: any) => ({ ...option, selected: 1 }));

  //           setSelectedOptionsMembers(selectedMembers);
  //         // }
  //       // }
  //     } catch (error) {
  //       console.error("Error fetching team members:", error);
  //     }
  //   };
  //   useEffect(() => {

  //     fetchData();
  //   }, [personalDetailState, props.eventForEdit]);






  // Re-run if data changes
  // useEffect(() => {
  //   if (personalDetailState?.data?.length > 0) {
  //     const assignedUsers = personalDetailState.data[0].AssignToUser || []; // Extract assigned users

  //     if (Array.isArray(assignedUsers) && assignedUsers.length > 0) {
  //       console.log(leadOptionMembers,assignedUsers,"leadOptionleadOption")

  //       const selectedData = leadOptionMembers
  //         .flatMap((member: any) =>
  //           member?.team_members?.map((mem: any) => {
  //             const isSelected = assignedUsers.some(
  //               (assignedUser: any) => assignedUser._id === mem.users[0]._id // Match by user ID
  //             );

  //             return {
  //               pId: member._id,
  //               id: mem.users[0]._id,
  //               label: mem.users[0]?.name,
  //               selected: isSelected ? 1 : 0, // Mark as selected if the user is in assigned list
  //             };
  //           })
  //         )
  //         .filter((item: any) => item.selected === 1); // Filter to keep only selected members

  //       setSelectedOptionsMembers(selectedData);
  //     }
  //   }
  // }, [personalDetailState, leadOptionMembers]); // Re-run if data or leadOptionMembers changes


  useEffect(() => {
    getStageDataNew()
  }, [])
  useEffect(() => {
    if (personalDetailState?.data[0]?.dynamicFields) {
      getFielsValue();
    }
  }, [personalDetailState?.data[0]?.dynamicFields]);

  const filterStagesByIsSale = (stages: any[], isSale: number): any[] => {
    return stages
      .map((stage) => {
        const subStages = filterStagesByIsSale(stage.sub_Stage_name || [], isSale);

        if (stage.isSale === isSale || stage.isSale === -1 || subStages.length > 0) {
          return {
            ...stage,
            sub_Stage_name: subStages,
          };
        }

        return null;
      })
      .filter((stage) => stage !== null);
  };
  const getStageDataNew = async () => {
    try {
      const resData = await getStage();
      setAllStagedata(resData.data);

      const userData = store.getState().auth.userId;
      const response = await getOfficeDetails(userData);
      const teamRoleName = response.data.teamRoleName.toLowerCase();
      let filteredStageData;

      // if (teamRoleName.includes("presales")) {
      //   filteredStageData = filterStagesByIsSale(resData.data, 0);
      // } else if (teamRoleName.includes("sales")) {
      //   filteredStageData = filterStagesByIsSale(resData.data, 1);
      // } else {
      // filteredStageData = resData.data;
      // }
      // setAllStagedata(filteredStageData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const tabelDataForEdit = async () => {
    const lead = props.eventForEdit;
    if (!lead?._id) return;

    try {
      const response =
        lead.lead_type === "upload_type" ? await getAllUsers() : "";
      const val =
        lead.lead_type === "upload_type"
          ? response?.data?.filter((e: any) => e._id === lead.formId)
          : "";
      const fields =
        lead.lead_type === "upload_type" ? (val?.[0]?.dynamicFields || []) : "";

      const valueoffield =
        lead.lead_type === "upload_type"
          ? fields?.map((item: any) => {
              const answers = Array.isArray(lead?.dynamicFields)
                ? lead.dynamicFields[0]
                : lead?.dynamicFields;
              return {
                ...item,
                answer: answers?.[item?.name],
              };
            })
          : "";

      const data =
        lead.lead_type === "upload_type"
          ? { ...lead, dynamicFields: valueoffield }
          : lead;

      const fullPhone = splitPhone(lead.leadPhone || "");

      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        formId: {
          error: "",
          value: lead.form_name || "",
          id: lead.formId || "",
        },
        data: [data],
        leadName: { value: lead.leadName || "", error: "" },
        leadEmail: { value: lead.leadEmail || "", error: "" },
        leadPhone: { value: fullPhone.phoneNumber || "", error: "" },
        phoneCountryCode: {
          dialCode: fullPhone.dialCode || "",
          code: fullPhone.country?.code || "",
        },
        id: lead._id,
        source: { source: lead.source || "", id: lead._id },
        stage: { stage: lead.stage || "", id: lead._id },
      }));

      const leadAssignData = Array.isArray(lead.AssignTo) ? lead.AssignTo : [];
      let transformedData = leadAssignData
        .map((team: any) => {
          const id = toLeadEntityId(team);
          if (!id) return null;
          let teamMembers: any[] = [];
          if (team?.teamRole) {
            try {
              const parsed =
                typeof team.teamRole === "string"
                  ? JSON.parse(team.teamRole)
                  : team.teamRole;
              teamMembers = Array.isArray(parsed)
                ? parsed.map((member: any) => ({
                    id: member.id || member._id,
                    label: member.role || member.name || member.label || "",
                    selected: 1,
                  }))
                : [];
            } catch {
              teamMembers = [];
            }
          }
          return {
            id,
            label: team?.team_name || team?.label || team?.name || id,
            selected: 1,
            teamMembers,
          };
        })
        .filter(Boolean);

      // API may return AssignTo as encoded ID string(s)
      if (!transformedData.length) {
        const teamIds = parseLeadAssignIds(lead.AssignTo);
        transformedData = teamIds.map((id) => ({
          id,
          label: id,
          selected: 1,
          teamMembers: [],
        }));
      }

      setSelectedOptions(transformedData);
      setLeadOption((prev: any) => {
        if (!Array.isArray(prev) || !prev.length) return prev;
        const selectedIds = new Set(
          transformedData.map((t: any) => String(t.id))
        );
        return prev.map((item: any) => ({
          ...item,
          selected: selectedIds.has(String(item.id)) ? 1 : 0,
          label:
            selectedIds.has(String(item.id)) && item.label
              ? item.label
              : item.label,
        }));
      });

      // Prefer named labels from team dropdown when only IDs were available
      setSelectedOptions((prev: any) =>
        prev.map((t: any) => {
          const match = (leadOption || []).find(
            (o: any) => String(o.id) === String(t.id)
          );
          return match?.label && (!t.label || t.label === t.id)
            ? { ...t, label: match.label, teamMembers: match.teamMembers || t.teamMembers }
            : t;
        })
      );

      const ids = transformedData.map((e: any) => e.id).filter(Boolean);
      const assignedUserIds = new Set(
        Array.isArray(lead.AssignToUser)
          ? lead.AssignToUser.map(toLeadEntityId).filter(Boolean)
          : parseLeadAssignIds(lead.AssignToUser)
      );

      if (ids.length > 0) {
        const payload = {
          team_id: ids,
          projectId: lead.projectId || "",
        };

        const response1 = await getAllTeamMembersDataProject(payload);
        const memberRows = Array.isArray(response1?.data) ? response1.data : [];

        const updatedLeadOptions = memberRows
          .flatMap((member: any) => {
            return (member?.team_members || []).map((mem: any) => {
              const user = mem?.users?.[0] || {};
              const memberId = user._id || mem.userId || mem.id;
              const userName = user?.name || mem?.name || "";
              if (!memberId || !userName) return null;
              const isSelected = assignedUserIds.has(String(memberId));
              return {
                pId: member._id,
                id: memberId,
                label: userName,
                selected: isSelected ? 1 : 0,
              };
            });
          })
          .filter(Boolean);

        setLeadOptionMembersas(updatedLeadOptions);

        const selectedFromApi = updatedLeadOptions.filter(
          (m: any) => m.selected === 1
        );
        if (selectedFromApi.length) {
          setSelectedOptionsMembers(selectedFromApi);
        } else if (Array.isArray(lead.AssignToUser)) {
          setSelectedOptionsMembers(
            lead.AssignToUser.map((member: any) => ({
              id: toLeadEntityId(member),
              label: member?.name || member?.label || toLeadEntityId(member),
              selected: 1,
            })).filter((m: any) => m.id)
          );
        } else {
          setSelectedOptionsMembers(
            Array.from(assignedUserIds).map((id) => ({
              id,
              label: id,
              selected: 1,
            }))
          );
        }
      } else if (Array.isArray(lead.AssignToUser) && lead.AssignToUser.length) {
        setSelectedOptionsMembers(
          lead.AssignToUser.map((member: any) => ({
            id: toLeadEntityId(member),
            label: member?.name || member?.label || toLeadEntityId(member),
            selected: 1,
          })).filter((m: any) => m.id)
        );
      }

      const dynamicFields = Array.isArray(lead?.dynamicFields)
        ? lead.dynamicFields
        : valueoffield || lead?.dynamicFields;
      setFormFiels({
        fieldData: dynamicFields || [],
      });
    } catch (error) {
      console.error("Failed to prefill lead edit form:", error);
    }
  };
  // const handleOptionCheckboxChange1 =
  //   (option: any, value: any) => (event: any, index: any) => {
  //     if (event.target.checked) {
  //       setIdForMember((prev: any) => [...prev, option.id]);
  //       const opt = { ...option, ["selected"]: 1 };
  //       const objIndex = leadOptionMembers.findIndex(
  //         (item: any) => item.id === option.id
  //       );
  //       leadOptionMembers[objIndex] = opt;
  //       setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);

  //       console.log("chirag", option, selectedOptions, leadOption, objIndex);
  //       setSelectedOptionsMembers([...selectedOptionsMembers, opt]);
  //     } else {
  //       setSelectedOptionsMembers(
  //         selectedOptionsMembers.filter((item: any) => item.id !== option.id)
  //       );
  //       // setSelectedOptionsMembers
  //       const opt = { ...option, ["selected"]: 0 };
  //       const objIndex = leadOptionMembers.findIndex(
  //         (item: any) => item.id === option.id
  //       );
  //       leadOptionMembers[objIndex] = opt;
  //       setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
  //       setIdForMember(idForMember.filter((item: any) => item !== option?.id));
  //       console.log(selectedOptionsMembers, option, "memberselectttt");
  //     }
  //   };
  // const handleOptionCheckboxChange = (option: any, event: any) => {
  //   const isChecked = event.target.checked ?? !option.selected; // Handle li & checkbox clicks

  //   if (isChecked) {
  //     const updatedOption = { ...option, selected: 1 };
  //     setSelectedOptions([...selectedOptions, updatedOption]);
  //     setLeadOption((prev: any) =>
  //       prev.map((item: any) => (item.id === option.id ? updatedOption : item))
  //     );

  //     if (option.teamMembers) {
  //       setLeadOptionMembersas((prev: any) => [
  //         ...prev,
  //         ...option.teamMembers.map((member: any) => ({
  //           pId: option.id,
  //           id: member.id,
  //           label: member.label,
  //           selected: 0,
  //         })),
  //       ]);
  //     }
  //   } else {
  //     setSelectedOptions(selectedOptions.filter((item: any) => item.id !== option.id));
  //     setLeadOptionMembersas(leadOptionMembers.filter((item: any) => item.pId !== option.id));

  //     // setLeadOption((prev: any) =>
  //     //   prev.map((item: any) => (item.id === option.id ? { ...item, selected: 0 } : item))
  //     // );
  //     setLeadOption((prev: any) =>
  //       prev.map((item: any) =>
  //         item.id === option.id ? { ...item, selected: isChecked ? 1 : 0 } : item
  //       )
  //     );
  //   }
  // };

  const handleOptionCheckboxChange = (option: any, event: any) => {
    event.stopPropagation();

    // --- Handle Select All separately ---
    if (option.id === "select_all") {
      const allSelected = selectedOptions.length === leadOption.length && leadOption.length > 0;

      if (allSelected) {
        // Unselect everything
        setSelectedOptions([]);
        setLeadOption((prev: any) => prev.map((item: any) => ({ ...item, selected: 0 })));
        setLeadOptionMembersas([]); // remove all team members
      } else {
        // Select everything
        const allUpdated = leadOption.map((item: any) => ({ ...item, selected: 1 }));
        setSelectedOptions(allUpdated);
        setLeadOption(allUpdated);
        // Add all team members
        const allMembers = leadOption.flatMap((opt: any) =>
          opt.teamMembers
            ? opt.teamMembers.map((m: any) => ({
              pId: opt.id,
              id: m.id,
              label: m.label,
              selected: 0,
            }))
            : []
        );
        setLeadOptionMembersas(allMembers);
      }
      return;
    }

    // --- Normal single option toggle ---
    const isChecked = event.target.checked ?? !option.selected;
    if (isChecked) {
      const updatedOption = { ...option, selected: 1 };

      // Update selectedOptions
      setSelectedOptions((prev: any) => [...prev, updatedOption]);

      // Update leadOption
      setLeadOption((prev: any) =>
        prev.map((item: any) => (item.id === option.id ? updatedOption : item))
      );

      // Add team members if applicable
      if (option.teamMembers) {
        setLeadOptionMembersas((prev: any) => [
          ...prev,
          ...option.teamMembers.map((member: any) => ({
            pId: option.id,
            id: member.id,
            label: member.label,
            selected: 0,
          })),
        ]);
      }
    } else {
      // Remove from selectedOptions and update leadOption
      setSelectedOptions((prev: any) => prev.filter((item: any) => item.id !== option.id));

      setLeadOption((prev: any) =>
        prev.map((item: any) =>
          item.id === option.id ? { ...item, selected: 0 } : item
        )
      );

      // Remove associated team members if applicable
      setLeadOptionMembersas((prev: any) => prev.filter((m: any) => m.pId !== option.id));
    }
  };

  const handleAssignToMember = (option: any, isChecked: boolean) => {
    // --- Handle Select All separately ---
    if (option.id === "select_all") {
      const allSelected = selectedOptionsMembers.length === uniqueLeadOptionMembers.length && uniqueLeadOptionMembers.length > 0;

      if (allSelected) {
        // Unselect everything
        setSelectedOptionsMembers([]);
        setLeadOptionMembersas((prev: any) => prev.map((item: any) => ({ ...item, selected: 0 })));
        setIdForMember([]);
      } else {
        // Select everything
        const allUpdated = uniqueLeadOptionMembers.map((item: any) => ({ ...item, selected: 1 }));
        setSelectedOptionsMembers(allUpdated);
        setLeadOptionMembersas(allUpdated);
        setIdForMember(allUpdated.map((item: any) => item.id));
      }
      return;
    }

    // --- Normal single option toggle ---
    const updatedOption = { ...option, selected: isChecked ? 1 : 0 };

    // Update leadOptionMembers state
    setLeadOptionMembersas((prev: any) =>
      prev.map((item: any) => (item.id === option.id ? updatedOption : item))
    );

    // Update selected options
    const updatedSelectedOptions = isChecked
      ? [...selectedOptionsMembers, updatedOption]
      : selectedOptionsMembers.filter((item: any) => item.id !== option.id);
    setSelectedOptionsMembers(updatedSelectedOptions);

    // Update idForMember array
    const updatedIdForMember = isChecked
      ? [...idForMember, option.id]
      : idForMember.filter((id: any) => id !== option.id);
    setIdForMember(updatedIdForMember);
  };

  const flattenStageData = (
    data: any[]
  ): { label: string; isParent: boolean }[] => {
    const result: { label: string; isParent: boolean }[] = [];

    const extractStageNames = (stages: any[]) => {
      stages.forEach((stage) => {
        if (stage.stage_Name) {
          result.push({ label: stage.stage_Name, isParent: true }); // Parent entry
        }
        if (stage.sub_Stage_name && Array.isArray(stage.sub_Stage_name)) {
          stage.sub_Stage_name.forEach((subStage: any) => {
            result.push({ label: subStage.stage_Name, isParent: false }); // Child entry
          });
        }
      });
    };

    extractStageNames(data);
    return result;
  };

  const stageOptions = flattenStageData(allSatgedata);
  // const handelDropdownAfterSelectEdit = async (ids: any, value: any) => {
  //   try {
  //     const payload = {
  //       team_id: ids,
  //       project_id: value,
  //     };
  //     console.log(ids, "idssss");

  //     const response1 = await getAllTeamMembersDataProject(payload);

  //     setLeadOptionMembersas(
  //       response1.data.flatMap((member: any) => {
  //         return member?.team_members?.map((mem: any) => {

  //           return {
  //             pId: member._id,
  //             id: mem.users[0]._id,
  //             label: mem.users[0]?.name,
  //             selected: mem?.is_available,
  //           };
  //         });
  //       })
  //     );

  //     setSelectedOptionsMembers(
  //       response1.data
  //         .flatMap((member: any) => {
  //           return member?.team_members?.map((mem: any) => {


  //             return {
  //               pId: member._id,
  //               id: mem.users[0]._id,
  //               label: mem.users[0]?.name,
  //               selected: mem?.is_available,
  //             };
  //           });
  //         })
  //         .filter((item: any) => item.selected === 1)
  //     );
  //   } catch { }
  // };
  // const handelDropdownAfterSelect1 = async (ids: any, value: any = null) => {
  //   try {
  //     const payload = {
  //       team_id: ids,
  //       project_id: value,
  //     };
  //     const response1 = await getAllTeamMembersDataProject(payload);
  //     setLeadOptionMembersas(
  //       response1.data.flatMap((member: any) => {
  //         return member?.team_members?.map((mem: any) => {
  //           return {
  //             pId: member._id,
  //             id: mem.users[0]._id,
  //             label: mem.users[0]?.name,
  //             selected: mem?.is_available,
  //           };
  //         });
  //       })
  //     );
  //     const members = response1.data
  //       .flatMap((member: any) => {
  //         return member?.team_members?.map((mem: any) => {
  //           return {
  //             pId: member._id,
  //             id: mem.users[0]?._id,
  //             label: mem.users[0]?.name,
  //             selected: mem?.is_available,
  //           };
  //         });
  //       })
  //       .filter((item: any) => item.selected === 1);

  //     setSelectedOptionsMembers(
  //       response1.data
  //         .flatMap((member: any) => {
  //           return member?.team_members?.map((mem: any) => {
  //             return {
  //               pId: member._id,
  //               id: mem.users[0]._id,
  //               label: mem.users[0]?.name,
  //               selected: mem?.is_available,
  //             };
  //           });
  //         })
  //         .filter((item: any) => item.selected === 1)
  //     );
  //   } catch { }
  // };
  const handelDropdownAfterSelect = async (ids: any, value: any) => {
    try {
      // const payload = {
      //   team_id: ids,
      //   projectId: value ? value : "",
      // };
      // const response1 = await getAllTeamMembersDataProject(payload);
      // console.log(response1, "chiragtyagi");

      // setLeadOptionMembersas(
      //   response1.data.flatMap((member: any) => {
      //     return member?.team_members?.map((mem: any) => {
      //       console.log(mem, member, "memberrrr");

      //       return {
      //         pId: member._id,
      //         id: mem.users[0]._id,
      //         label: mem.users[0]?.name,
      //         selected: 1,
      //       };
      //     });
      //   })
      // );
      const payload = {
        team_id: ids,
        projectId: value ? value : "",
      };
      const response1 = await getAllTeamMembersDataProject(payload);

      // Check if the `selectedLeadOption` already has members and update accordingly
      setLeadOptionMembersas(
        response1.data.flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            // Check if this member is already in selectedLeadOption
            const isSelected = selectedOptions.some((selected: any) => selected.id === mem.users[0]._id);

            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: isSelected ? 1 : 0, // Mark as selected if in selectedLeadOption
            };
          });
        })
      );


      setSelectedOptionsMembers(
        response1.data
          .flatMap((member: any) => {
            return member?.team_members?.map((mem: any) => {

              return {
                pId: member._id,
                id: mem.users[0]._id,
                label: mem.users[0]?.name,
                // selected: mem?.is_available,
                selected: 1,
              };
            });
          })
          .filter((item: any) => item.selected === 1)
      );
    } catch { }
  };
  const fetchAssignDetails = async (value: any) => {
    try {
      const response1 = await getAllTeamDataProject(value);
      const assignToData = response1.data.flatMap((team: any) => {
        const subTeams = team.sub_teams?.map((subTeam: any) =>

        ({

          id: subTeam._id,
          label: subTeam.team_name,
          selected: subTeam?.is_available,
          isParent: false,
          teamMembers: subTeam.team_members.length
            ? subTeam.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,

        })) || [];

        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent: true,
          teamMembers: team.team_members.length

            ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,
        };
        return [mainTeam, ...subTeams];
      })
      const viewerTeamIds = await loadViewerTeamIds();
      setLeadOption(
        viewerTeamIds == null
          ? assignToData
          : assignToData.filter((team: any) =>
              viewerTeamIds.includes(String(team?.id || ""))
            )
      );

      const selectedData = assignToData
        // .filter((e: any) => {
        //   return e?.selected == 1;
        // })
        .filter((e: any) => e?.is_available === 1)
        .map((e: any) => {
          console.log(e, "Processing in map");
          return {
            id: e.id,
            label: e.label,
            selected: e?.selected,
            teamMembers: Array.isArray(e.teamMembers)
              ? e.teamMembers.map((member: any) => ({
                id: member.id,
                label: member.label,
                selected: 0,
              }))
              : null,
          };
        });

      setSelectedOptions(
        selectedData
      );


      const ids = assignToData
        .filter((e: any) => e?.is_available === 1)

        // .filter((e: any) => e?.selected === 1)
        .map((e: any) => e.id);
      if (ids) {
        handelDropdownAfterSelect(ids, value);
      }
      // setLeadOption(
      //   response1.data.map((e: any) => {
      //     return {
      //       id: e._id,
      //       label: e.team_name,
      //       selected: e?.is_available,
      //       teamMembers: e.team_members.length
      //         ? e.team_members.map((member: any) => {
      //             return {
      //               id: member.userId,
      //               label: member.users[0].name,
      //               selected: 0,
      //             };
      //           })
      //         : null,
      //     };
      //   })
      // );
      // setSelectedOptions(
      //   response1.data
      //     .filter((e: any) => e?.is_available === 1)
      //     .map((e: any) => {
      //       return {
      //         id: e._id,
      //         label: e.team_name,
      //         selected: e?.is_available,
      //         teamMembers: e.team_members.length
      //           ? e.team_members.map((member: any) => {
      //               return {
      //                 id: member.userId,
      //                 label: member.users[0].name,
      //                 selected: 0,
      //               };
      //             })
      //           : null,
      //       };
      //     })
      // );

      // const ids = response1.data
      //   .filter((e: any) => e?.is_available === 1)
      //   .map((e: any) => e._id);
      // console.log(ids, "idssss");
      // if (ids) {
      //   handelDropdownAfterSelectEdit(ids, value);
      // }
    } catch { }
  };
  const handleOnChangeInputField = (event: any) => {
    const name: any = event.target.name;
    const value: any = event.target.value;
    const isGoForward: any = validateInput(name, value);
    if (name === "leadPhone" && value.length > 10) return;
    let error = "";

    if (!isGoForward) return;
    setPersonalDetailState((prevState: any) => ({
      ...prevState,
      [name]: { value, error },
    }));
  };
  const handleAutocompleteChange = async (name: string, value: any) => {
    if (name === "formId") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        ["formId"]: {
          error: "",
          value: value.label,
          id: value.id,
        },
      }));
      setFormFiels((prevFormDataFields: any) => ({
        ["fieldData"]: props.eventForEdit?.dynamicFields,
      }));
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        data: state.filter((e: any) => {
          return value.id == e._id;
        }),
      }));
      const data: any = state.filter((e: any) => {
        return value.id == e._id;
      });
      const projectId = data[0]?.projectId;
      fetchAssignDetails(projectId);
    }
    if (name === "selectFiels") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          value: value.label,
        },
      }));
    }
  };
  // const handleAutocompleteChangeField = async (
  //   name: string,
  //   val: string,
  //   value: any
  // ) => {
  //   if (val === "select") {
  //     setPersonalDetailState((prevFormData: any) => ({
  //       ...prevFormData,
  //       [name]: {
  //         value: value.label,
  //       },
  //     }));
  //   }
  // };
  // const init = async () => {

  //   if (props.userId) {
  //     setApiResponse(true);
  //     try {
  //       let response = await getPerosnalDetails(props.userId);
  //       customErrorHandler(response);
  //       setPersonalDetailState(initialState(response.data, true));
  //       clonedObject = _.cloneDeep(initialState(response.data, true));
  //       setApiResponse(false);
  //     } catch (error: any) {
  //       setApiResponse(false);
  //       openErrorNotification(
  //         isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
  //       );
  //     }
  //   }
  // };
  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      const response1 = await getAllTeam();
      const response2 = await getAllStage();
      setStageData(
        response2.data.map((e: any) => {
          return e.status_name;
        })
      );
      const response3 = await getAllSource();
      setStageSourse(
        response3.data.map((e: any) => {
          return e.source_name;
        })
      );
      const assignToData = response1.data.flatMap((team: any) => {
        const subTeams = team.sub_teams?.map((subTeam: any) =>

        ({

          id: subTeam._id,
          label: subTeam.team_name,
          selected: subTeam?.is_available,
          isParent: false,
          teamMembers: subTeam.team_members.length
            ? subTeam.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,

        })) || [];

        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent: true,
          teamMembers: team.team_members.length

            ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,
        };
        return [mainTeam, ...subTeams];
      })
      const viewerTeamIds = await loadViewerTeamIds();
      setLeadOption(
        viewerTeamIds == null
          ? assignToData
          : assignToData.filter((team: any) =>
              viewerTeamIds.includes(String(team?.id || ""))
            )
      );

      const response = await getAllUsers();
      setState(
        response.data.map((e: any) => {
          return e;
        })
      );
      setFormName(
        (response.data || [])
          ?.filter((item: any) => String(item.status) === "1")
          ?.map((i: any) => {
            return { id: i._id, label: i.form_name };
          })
      );
      if (!props.addNewTeamDialog?.edit) {
        setPersonalDetailState((prevState: any) => ({
          ...prevState,
          leadName: { value: "", error: "" },
          leadEmail: { value: "", error: "" },
          leadPhone: { value: "", error: "" },
          data: [],
        }));
      }
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleAutocompleteChange2 = async (
    name: string,
    value: any,
    data: any
  ) => {
    // const isGoForward: any = validateInput(name, value);
    // // if (!isGoForward) return;

    if (name === "stage") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["stage"]: value,
        },
      }));
      try {
        // setApiResponse(true);
        // const response = await changeStage(body);
        // tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }

    if (name === "assignTo") {
      // const body = {

      // };
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["AssignTo"]: value?.id,
        },
      }));
      try {
        setApiResponse(true);
        // const response = await changeAt(body);

        // tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
    if (name === "source") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["source"]: value,
        },
      }));
    }
  };
  // submit mepersonalDetailStatethod
  const submitForm = async () => {
    if (props.userId) {
      try {
        const idTeam = selectedOptions.map((item: any) => {
          return `'${item.id}'`;
        });
        const idMembers = selectedOptionsMembers.map((item: any) => {
          return `'${item.id}'`;
        });
        const body = [
          {
            // ...personalDetailState.data[0],
            ["leadName"]: personalDetailState.leadName.value,
            ["formId"]: personalDetailState.formId.id,

            ["dynamicFields"]: formFielsAns.tempList,
            ["leadEmail"]: personalDetailState.leadEmail.value,
            ["leadPhone"]: `${personalDetailState?.phoneCountryCode?.dialCode || ""}${personalDetailState.leadPhone?.value || ""}`,


            // ["AssignTo"]: personalDetailState.assignTo?.AssignTo || "NA",
            // ["AssignTo"]:selectedOptions.map((item:any) => item.id),
            // ["AssignToUser"]:selectedOptionsMembers.map((item:any) => item.id),
            ["AssignTo"]: idTeam.join(",") || "NA",
            ["AssignToUser"]: idMembers.join(",") || "NA",
            ["stage"]: personalDetailState.stage || "NA",

            ["id"]: personalDetailState.id,
          },
        ];
        // const body = { ...personalDetailState };
        // body.userId = { value: props.userId, error: "" };
        const response = await updatePersonalDetail(body[0]);
        if (response?.success) {
          openSuccessNotification(response?.message);
          // props.nextStep?.();
          props.handleCloseAddTeam();
        } else {
          customErrorHandler(response);
        }
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
        );
      }
    } else {
      const validatedObject: any = handleValidation(personalDetailState);
      if (
        validatedObject?.leadName.error ||
        validatedObject.leadPhone.error ||
        validatedObject.leadEmail.error
      ) {
        setPersonalDetailState({ ...validatedObject });
        return;
      }
      try {
        const idTeam = selectedOptions.map((item: any) => {
          return `'${item.id}'`;
        });
        const idMembers = selectedOptionsMembers.map((item: any) => {
          return `'${item.id}'`;
        });
        const body = {
          ...personalDetailState?.data[0],
          ["leadName"]: personalDetailState.leadName.value,
          ["formId"]: personalDetailState.formId.id,
          ["dynamicFields"]: personalDetailState.data[0]?.dynamicFields,
          ["leadEmail"]: personalDetailState.leadEmail.value,
          ["leadPhone"]: `${personalDetailState?.phoneCountryCode?.dialCode || ""}${personalDetailState.leadPhone?.value || ""}`,

          ["AssignTo"]: idTeam.join(",") || "NA",
          ["AssignToUser"]: idMembers.join(",") || "NA",
          ["stage"]: personalDetailState.stage?.stage?.label,
          ["source"]: personalDetailState.source?.source,
          ["organizationId"]: organizationId || undefined,
        };
        const response = await RegisterEmployee(body);
        if (response?.success) {
          openSuccessNotification(response?.message);
          props.handleCloseAddTeam();
          // props?.setUserId && props?.setUserId(response.data._id);
          // setPersonalDetailState(response.data);
          // openSuccessNotification(response?.message);
          // props.nextStep?.();
        } else {
          const msg = isTruthy(response?.message)
            ? response.message
            : "Unable to save lead. Please try again.";
          openErrorNotification(msg);
          if (
            response?.status === 409 ||
            response?.code === "LEAD_DUPLICATE"
          ) {
            const isEmailDup = /email/i.test(String(msg));
            setPersonalDetailState((prev: any) => ({
              ...prev,
              ...(isEmailDup
                ? {
                    leadEmail: {
                      ...prev.leadEmail,
                      error: msg,
                    },
                  }
                : {
                    leadPhone: {
                      ...prev.leadPhone,
                      error: msg,
                    },
                  }),
            }));
          }
        }
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };

  const submitFormRef = useRef(submitForm);
  submitFormRef.current = submitForm;

  useEffect(() => {
    props.registerStepActions?.({
      submit: () => submitFormRef.current?.(),
    });
  }, [props.registerStepActions]);

  const onChangeHandlerForDate = (value: any) => {
    const date = new Date(value).toLocaleDateString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    });
    setPersonalDetailState({
      ...personalDetailState,
      dob: {
        error: "",
        value: date,
      },
    });
  };

  // const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
  //   if (event.key === "Enter") {
  //     event.preventDefault();
  //     const inputs = document.getElementsByTagName("input");
  //     const currentIndex = Array.from(inputs).indexOf(
  //       event.target as HTMLInputElement
  //     );
  //     const nextIndex = currentIndex + 1;

  //     if (nextIndex < inputs.length) {
  //       inputs[nextIndex].focus();
  //     } else {
  //       // If the last input field is reached, trigger the submitForm function
  //       submitForm();
  //     }
  //   }
  // };
  const getFielsValue = () => {
    setFormFiels((prevFormDataFields: any) => ({
      ["fieldData"]: personalDetailState?.data[0]?.dynamicFields,
    }));
    setFormFielsAns((prevFormDataFields: any) => ({
      ["fieldData"]: personalDetailState?.data[0]?.dynamicFields,
    }));
  };
  function handleRadioChange(
    event: React.ChangeEvent<HTMLInputElement>,
    selectedOption: string,
    val: any
  ) {
    // Your logic to handle the selected radio button
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [val]: {
        value: selectedOption,
      },
    }));
    // Call your desired function or perform any actions here
  }
  const handleCheckBoxChange = (name: any) => {
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: {
        value: !prevFormData[name]?.value ? 1 : 0,
      },
    }));
  };

  const parseFieldOptions = (options: any): string[] => {
    if (Array.isArray(options)) {
      return options
        .map((opt: any) =>
          typeof opt === "object" && opt != null
            ? String(opt.label ?? opt.value ?? opt.name ?? "")
            : String(opt ?? "")
        )
        .map((s) => s.trim())
        .filter(Boolean);
    }
    if (typeof options === "string") {
      return options
        .split(";")
        .map((opt: string) => opt.trim())
        .filter(Boolean);
    }
    return [];
  };

  const getCode = (dt: any, i: any) => {
    switch (dt?.type) {
      case "text":
        return (
          <YhInput
            key={`${dt?.name}-${i}`}
            label={dt?.name ? dt?.name : dt?.type}
            placeholder={dt?.placeholder ? dt?.placeholder : dt.type}
            onChange={(event: any) => {
              let tempList = formFiels.fieldData;
              let obj = tempList[i];
              obj = { ...obj, answer: event.target.value };
              tempList[i] = obj;

              setFormFielsAns((prevFormDataFields: any) => ({
                ...prevFormDataFields,
                tempList,
              }));
            }}
            value={dt.answer || ""}
            name={dt?.name ? dt?.name : dt?.type}
            type="text"
          />
        );
      case "radio":
        return (
          <div key={`${dt?.name}-${i}`} className="w-full">
            <p className="yh-label">{dt?.name}</p>
            <div className="mt-1 flex flex-wrap gap-4">
              {parseFieldOptions(dt.options).map((e: any) => (
                <label
                  key={e}
                  className="flex cursor-pointer items-center gap-2 text-sm text-[#374151]"
                >
                  <input
                    type="radio"
                    name={`radio-${dt?.name}-${i}`}
                    value={e}
                    checked={dt.answer === e}
                    onChange={(event) => {
                      let tempList = formFiels.fieldData;
                      let obj = tempList[i];
                      obj = {
                        ...obj,
                        answer: event.target.value,
                      };
                      tempList[i] = obj;

                      setFormFielsAns((prevFormDataFields: any) => ({
                        ...prevFormDataFields,
                        tempList,
                      }));
                    }}
                    className="h-4 w-4 accent-[#2563EB]"
                  />
                  {e}
                </label>
              ))}
            </div>
          </div>
        );
      case "select":
        return (
          <YhSelect
            key={`${dt?.name}-${i}`}
            label={dt?.name}
            placeholder="Select your ans"
            value={dt.answer || ""}
            options={parseFieldOptions(dt.options).map((e: any) => ({
              label: e,
              value: e,
            }))}
            onChange={(event) => {
              let tempList = formFiels.fieldData;
              let obj = tempList[i];
              obj = { ...obj, answer: event.target.value };
              tempList[i] = obj;

              setFormFielsAns((prevFormDataFields: any) => ({
                ...prevFormDataFields,
                tempList,
              }));
            }}
          />
        );
      case "checkbox":
        return (
          <label
            key={`${dt?.name}-${i}`}
            className="flex cursor-pointer items-center gap-2 text-sm text-[#374151]"
          >
            <input
              type="checkbox"
              checked={!!dt.answer}
              onChange={(event: any) => {
                let tempList = formFiels.fieldData;
                let obj = tempList[i];
                obj = { ...obj, answer: event.target?.checked ? true : false };
                tempList[i] = obj;

                setFormFiels((prevFormDataFields: any) => ({
                  ...prevFormDataFields,
                  tempList,
                }));
              }}
              className="h-4 w-4 rounded accent-[#2563EB]"
            />
            {dt.name}
          </label>
        );
      case "textarea":
        return (
          <div key={`${dt?.name}-${i}`} className="w-full">
            <label htmlFor={`textarea-${dt?.name}-${i}`} className="yh-label">
              {dt?.name}
            </label>
            <textarea
              id={`textarea-${dt?.name}-${i}`}
              className="yh-input min-h-[100px] resize-y"
              rows={4}
              value={dt.answer || ""}
              onChange={(event) => {
                let tempList = formFiels.fieldData;
                let obj = tempList[i];
                obj = { ...obj, answer: event.target.value };
                tempList[i] = obj;

                setFormFielsAns((prevFormDataFields: any) => ({
                  ...prevFormDataFields,
                  tempList,
                }));
              }}
            />
          </div>
        );
      default:
        return null;
    }
  };
  const updateTextareaValue = (newValue: any, name: any) => {
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: {
        value: newValue,
      },
    }));
  };

  const phoneCountryCodeValue =
    personalDetailState?.phoneCountryCode?.code ||
    countryData.find(
      (c) => c.dialCode === personalDetailState?.phoneCountryCode?.dialCode
    )?.code ||
    "";

  const stageValue =
    (typeof personalDetailState?.stage?.stage === "object"
      ? personalDetailState?.stage?.stage?.label
      : personalDetailState?.stage?.stage) ||
    personalDetailState?.data?.[0]?.stage ||
    "";

  const sourceValue =
    personalDetailState?.source?.source ||
    personalDetailState?.data?.[0]?.source ||
    "";

  const handleTeamMultiChange = (values: Array<string | number>) => {
    const nextIds = new Set(values.map(String));
    const nextSelected = leadOption
      .filter((o: any) => nextIds.has(String(o.id)))
      .map((o: any) => ({ ...o, selected: 1 }));

    setSelectedOptions(nextSelected);
    setLeadOption((prev: any) =>
      prev.map((item: any) => ({
        ...item,
        selected: nextIds.has(String(item.id)) ? 1 : 0,
      }))
    );

    setLeadOptionMembersas((prevMembers: any) => {
      const nextMembers = nextSelected.flatMap((opt: any) =>
        (opt.teamMembers || []).map((m: any) => {
          const existing = prevMembers.find(
            (x: any) =>
              String(x.id) === String(m.id) && String(x.pId) === String(opt.id)
          );
          return {
            pId: opt.id,
            id: m.id,
            label: m.label,
            selected: existing?.selected ?? 0,
          };
        })
      );
      return nextMembers;
    });

    setSelectedOptionsMembers((prev: any) =>
      prev.filter((m: any) => nextIds.has(String(m.pId)))
    );
    setIdForMember((prev: any) =>
      Array.isArray(prev)
        ? prev.filter((id: any) =>
            nextSelected.some((t: any) =>
              (t.teamMembers || []).some((m: any) => String(m.id) === String(id))
            )
          )
        : []
    );
  };

  const handleMemberMultiChange = (values: Array<string | number>) => {
    const nextIds = new Set(values.map(String));
    const nextSelected = uniqueLeadOptionMembers
      .filter((o: any) => nextIds.has(String(o.id)))
      .map((o: any) => ({ ...o, selected: 1 }));

    setSelectedOptionsMembers(nextSelected);
    setLeadOptionMembersas((prev: any) =>
      prev.map((item: any) => ({
        ...item,
        selected: nextIds.has(String(item.id)) ? 1 : 0,
      }))
    );
    setIdForMember(nextSelected.map((item: any) => item.id));
  };

  useEffect(() => {
    let cancelled = false;
    loadViewerAssignScope().then((scope) => {
      if (!cancelled) setAssignScope(scope);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (assignScope?.role !== "leader" || !assignScope.teamIds.length) return;
    if (!Array.isArray(leadOption) || !leadOption.length) return;
    const wanted = assignScope.teamIds.map(String);
    const have = wanted.every((id) =>
      leadOption.some((option: any) => String(option.id) === id)
    );
    if (!have) return;
    const current = (selectedOptions || [])
      .map((option: any) => String(option.id))
      .sort()
      .join(",");
    if (current === [...wanted].sort().join(",")) return;
    handleTeamMultiChange(wanted);
    // Lock the team once options are loaded. handleTeamMultiChange updates selection.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignScope, leadOption]);

  const teamLocked =
    assignScope?.role === "leader" || assignScope?.role === "member";
  const memberLocked = assignScope?.role === "member";
  const lockedTeamOptions = (assignScope?.teams || []).map((team) => {
    const fromList = (leadOption || []).find(
      (option: any) => String(option.id) === String(team.id)
    );
    return {
      label: fromList?.label || team.label,
      value: String(team.id),
    };
  });

  return (
    <>
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-[#111827]">Select Form</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Choose a form and fill lead details.
        </p>
      </div>

      <div className="mb-4 w-full max-w-xl">
        <OrganizationSelect
          label="Organization"
          required
          value={organizationId}
          onChange={setOrganizationId}
        />
      </div>

      <div className="w-full max-w-xl">
        <YhSelect
          label="Form Name"
          placeholder="Select Your Form Name"
          value={personalDetailState?.formId?.id || ""}
          error={personalDetailState?.formId?.error}
          options={formName.map((option: any) => ({
            label: option.label,
            value: option.id,
          }))}
          onChange={(e) => {
            const selectedObject = formName.find(
              (option: any) => option.id === e.target.value
            );
            if (selectedObject) {
              handleAutocompleteChange("formId", selectedObject);
            }
          }}
        />
      </div>

      {personalDetailState?.formId?.id && (
        <div className="mt-6 space-y-6">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <YhInput
              label="Developer Name"
              value={personalDetailState?.data?.[0]?.developer_name || ""}
              readOnly
              disabled
            />

            <YhInput
              label="Project Name"
              value={personalDetailState?.data?.[0]?.project_name || ""}
              readOnly
              disabled
            />

            <YhInput
              label="Property Type"
              value={personalDetailState?.data?.[0]?.projecttype_name || ""}
              readOnly
              disabled
            />

            <div className="md:col-span-2 lg:col-span-1">
              <YhMultiSelect
                label="Assigned To"
                placeholder={teamLocked ? "Your team" : "Select teams..."}
                searchPlaceholder="Search teams..."
                disabled={teamLocked}
                options={
                  teamLocked
                    ? lockedTeamOptions
                    : Array.from(
                        new Map(
                          [...leadOption, ...selectedOptions]
                            .filter((o: any) => o?.id)
                            .map((option: any) => [
                              String(option.id),
                              {
                                label: option.label || String(option.id),
                                value: option.id,
                              },
                            ])
                        ).values()
                      )
                }
                value={
                  teamLocked
                    ? (assignScope?.teamIds || []).map(String)
                    : selectedOptions.map((o: any) => o.id)
                }
                onChange={teamLocked ? undefined : handleTeamMultiChange}
                maxVisibleChips={10}
              />
            </div>

            <div className="md:col-span-2 lg:col-span-1">
              <YhMultiSelect
                label="Assigned To Member"
                placeholder={
                  memberLocked ? assignScope?.userName || "You" : "Select members..."
                }
                searchPlaceholder="Search members..."
                disabled={memberLocked}
                options={
                  memberLocked
                    ? [
                        {
                          label: assignScope?.userName || "You",
                          value: assignScope?.userId || "",
                        },
                      ]
                    : Array.from(
                        new Map(
                          [
                            ...uniqueLeadOptionMembers,
                            ...selectedOptionsMembers,
                          ]
                            .filter((o: any) => o?.id)
                            .map((option: any) => [
                              String(option.id),
                              {
                                label: option.label || String(option.id),
                                value: option.id,
                              },
                            ])
                        ).values()
                      )
                }
                value={
                  memberLocked
                    ? [assignScope?.userId || ""].filter(Boolean)
                    : selectedOptionsMembers.map((o: any) => o.id)
                }
                onChange={memberLocked ? undefined : handleMemberMultiChange}
                maxVisibleChips={10}
              />
            </div>
          </div>

          <hr className="border-[#E5E7EB]" />

          <h3 className="text-base font-semibold text-[#111827]">Lead Details</h3>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <YhInput
              label="Name"
              placeholder="Enter Name"
              error={personalDetailState?.leadName?.error}
              value={personalDetailState?.leadName?.value || ""}
              onChange={handleOnChangeInputField}
              name="leadName"
              type="text"
              onKeyPress={handleKeyPress}
            />

            <YhInput
              label="Work Email"
              placeholder="xyz@xyz.com"
              error={personalDetailState?.leadEmail?.error}
              value={personalDetailState?.leadEmail?.value || ""}
              onChange={handleOnChangeInputField}
              name="leadEmail"
              type="text"
              onKeyPress={handleKeyPress}
            />

            <div className="grid grid-cols-[140px_1fr] gap-2">
              <YhSelect
                label="Code"
                placeholder="Code"
                searchable
                searchPlaceholder="Search country..."
                showOptionIcon={false}
                value={
                  phoneCountryCodeValue ||
                  personalDetailState?.phoneCountryCode?.code ||
                  defaultPhoneCountry().code
                }
                options={countryData.map((c) => ({
                  label: `${c.label} (${c.dialCode})`,
                  value: c.code,
                }))}
                onChange={(e) => {
                  const selected =
                    findPhoneCountry(e.target.value) ||
                    countryData.find((c) => c.code === e.target.value) ||
                    defaultPhoneCountry();
                  setPersonalDetailState({
                    ...personalDetailState,
                    phoneCountryCode: selected,
                  });
                }}
                onKeyPress={handleKeyPress as any}
              />
              <YhInput
                label="Phone Number"
                placeholder="XXX XXX XXXX"
                error={personalDetailState?.leadPhone?.error}
                value={personalDetailState?.leadPhone?.value || ""}
                onChange={handleOnChangeInputField}
                name="leadPhone"
                type="number"
                onKeyPress={handleKeyPress}
              />
            </div>

            <YhSelect
              label="Stage"
              placeholder="Select stage"
              searchPlaceholder="Search stages..."
              searchable
              showOptionIcon={false}
              value={stageValue}
              groups={buildStageSelectGroups(allSatgedata || [])}
              onChange={(e) => {
                const label = e.target.value;
                if (!label) return;
                const selectedOption =
                  stageOptions.find((opt) => opt.label === label) || {
                    label,
                    isParent: false,
                  };
                handleAutocompleteChange2(
                  "stage",
                  selectedOption,
                  personalDetailState?.data?.[0]
                );
              }}
            />

            <YhSelect
              label="Source"
              placeholder="Enter Your Source"
              value={sourceValue}
              options={stageSourse.map((source: string) => ({
                label: source,
                value: source,
              }))}
              onChange={(e) => {
                handleAutocompleteChange2(
                  "source",
                  e.target.value,
                  personalDetailState?.data?.[0]
                );
              }}
            />
          </div>

          {(formFiels.fieldData || []).length > 0 && (
            <>
              <hr className="border-[#E5E7EB]" />
              <h3 className="text-base font-semibold text-[#111827]">
                Additional Details
              </h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                {formFiels.fieldData?.map((e: any, i: any) => getCode(e, i))}
              </div>
            </>
          )}

          {!props.hideFooterButtons && (
            <div className="pb-3">
              <CustomButton
                label={`${props.userId ? "Edit & Save" : "Save "}`}
                onClick={submitForm}
                buttonType="primaryBtn"
                customClasses={classes.custombuttonStyle}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PersonalDetails;
